<template>
<v-form ref="form" v-model="valid">
  <v-container fluid>
     <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>

    </v-app-bar>
  </nav>

    <v-card-title>General</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Console S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="console"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chConsoleSn"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="board[0].chConsoleLabel"> </v-text-field>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Total of Sensor</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-radio-group
      v-model="board[0].totalSensor"
      row
    >
      <v-radio
        label="1" 
        :value = 1
      ></v-radio>
      <v-radio
        label="2"
        :value = 2 
      ></v-radio>
      <v-radio
        label="3"
        :value = 3
      ></v-radio>
      <v-radio
        label="4"
        :value = 4
      ></v-radio>
    </v-radio-group>
        </v-col>
      </v-row>
    </v-card>


    <v-card-title v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">Sensor Unit 1</v-card-title>
    <v-card v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">
    <v-card-title>A</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
         <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location1A"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_1A" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1A(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1A">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb1A.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb1A.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb1A.label"
        ></v-select>
        </v-col>
      </v-row>

    </v-card>

    <v-card-title>B</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName1"></v-text-field>
        </v-col>
      </v-row>

        <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
             <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location1B"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_1B" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1B(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1B">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb1B.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb1B.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb1B.label"
        ></v-select>
        </v-col>
      </v-row>

    </v-card>

    <v-card-title>C</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName1"></v-text-field>
        </v-col>
      </v-row>

        <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
             <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location1C"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_1C" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1C(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1C">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb1C.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb1C.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb1C.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

      <v-card-title>D</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName1"></v-text-field>
        </v-col>
      </v-row>

        <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
             <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location1D"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_1D" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1D(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1D">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb1D.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb1D.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb1D.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>E</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
          <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName1"></v-text-field>
        </v-col>
      </v-row>

        <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
             <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location1E"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_1E" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1E(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1E">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb1E.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb1E.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb1E.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>F</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName1"></v-text-field>
        </v-col>
      </v-row>

        <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
             <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location1F"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_1F" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1F(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1F">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb1F.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb1F.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb1F.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>G</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName1"></v-text-field>
        </v-col>
      </v-row>

        <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
             <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location1G"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_1G" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1G(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1G">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb1G.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb1G.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb1G.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>H</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName1"></v-text-field>
        </v-col>
      </v-row>

        <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
             <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location1H"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_1H" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1H(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1H">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb1H.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb1H.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb1H.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>
    </v-card>


    <v-card-title v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">Sensor Unit 2</v-card-title>
    <v-card v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">
    <v-card-title>A</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
         </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName2"></v-text-field>
        </v-col>
      </v-row>

        <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
             <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location2A"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_2A" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2A(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2A">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb2A.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb2A.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb2A.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>B</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
         </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName2"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location2B"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_2B" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2B(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2B">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb2B.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb2B.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb2B.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>C</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName2"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location2C"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_2C" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2C(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2C">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb2C.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb2C.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb2C.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

      <v-card-title>D</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName2"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location2D"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_2D" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2D(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2D">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb2D.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb2D.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb2D.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>E</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName2"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location2E"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_2E" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2E(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2E">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb2E.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb2E.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb2E.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>F</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName2"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location2F"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_2F" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2F(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2F">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb2F.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb2F.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb2F.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>G</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
         </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName2"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location2G"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_2G" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2G(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2G">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb2G.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb2G.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb2G.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>H</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName2"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location2H"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_2H" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2H(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2H">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb2H.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb2H.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb2H.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>
    </v-card>

    <v-card-title v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">Sensor Unit 3</v-card-title>
   <v-card v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">
    <v-card-title>A</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName3"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location3A"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_3A" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3A(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3A">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb3A.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb3A.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb3A.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>B</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName3"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location3B"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_3B" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3B(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3B">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb3B.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb3B.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb3B.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>C</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
         </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName3"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location3C"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_3C" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3C(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3C">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb3C.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb3C.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb3C.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

      <v-card-title>D</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName3"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location3D"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_3D" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3D(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3D">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb3D.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb3D.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb3D.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>E</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName3"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
         <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location3E"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_3E" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3E(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3E">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb3E.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb3E.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb3E.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>F</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName3"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location3F"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_3F" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3F(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3F">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb3F.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb3F.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb3F.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>G</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName3"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
         <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location3G"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_3G" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3G(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3G">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb3G.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb3G.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb3G.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>H</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName3"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
         <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location3H"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_3H" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3H(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3H">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb3H.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb3H.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb3H.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>
    </v-card>

    <v-card-title v-if="board[0].totalSensor == 4">Sensor Unit 4</v-card-title>
   <v-card v-if="board[0].totalSensor == 4">
    <v-card-title>A</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName4"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location4A"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_4A" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4A(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4A">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb4A.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb4A.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb4A.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>B</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName4"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location4B"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_4B" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4B(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4B">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb4B.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb4B.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb4B.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>C</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName4"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location4C"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_4C" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4C(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4C">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb4C.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb4C.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb4C.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

      <v-card-title>D</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName4"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location4D"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_4D" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4D(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4D">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb4D.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb4D.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb4D.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>E</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName4"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location4E"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_4E" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4E(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4E">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb4E.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb4E.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb4E.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>F</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName4"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location4F"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_4F" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4F(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4F">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb4F.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb4F.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb4F.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>G</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName4"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location4G"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_4G" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4G(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4G">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb4G.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb4G.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb4G.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>H</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="board[0].chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="board[0].boardName4"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="board[0].location4H"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in board[0].loadType_4H" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4H(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4H">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="board[0].ryb4H.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="board[0].ryb4H.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="board[0].ryb4H.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>
    </v-card>

     <v-btn fixed dark fab bottom right color="blue" @click="saveItem()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
  </v-container>
</v-form>
</template>


<script>
import axios from "axios";
import router from "../../router";

export default {
  data() {
    return {
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: '8 Channel Phase',
          disabled: false,
          href: '/board',
        },
        {
          text: 'Details',
          disabled: false,
          href: '/board/details/'+this.$route.params.id,
        },
        {
          text: 'Edit',
          disabled: true,
          href: '',
        },
      ],
    checkbox: false,
    loadTypeItems: ['User Wall Switches', 'Direct From DB', 'Main Socket'],
    userWallItems: ['Lighting', 'Fan', 'Aircond', 'Water Heater', 'Ventilation Fan'],
    directItems: ['Emergency Light', 'KELUAR Sign', 'Lift'],
    mainItems: ['TV', 'Hand Dryer', 'IT equipment', 'Washing Machine', 'Refrigerator', 'Cooking Ovens', 'Rail Sockets', 'Others'],
    phaseType: ['R','Y','B'],
    rybLabel: ['1R','1Y','1B','2R','2Y','2B','3R','3Y','3B','4R','4Y','4B','5R','5Y','5B','6R','6Y','6B','7R','7Y','7B','8R','8Y','8B','9R','9Y','9B','10R','10Y','10B','11R','11Y','11B'],
    board: [],
    boardAll: [],
    location: [],
    valid: true,
    console: [], 
    sensor: [], 
    showDeleteDialog: false,
    };
  },
  created() {
    this.loadsConsole();
    this.loadsSensor();
    this.loadsBoard();
    this.loadsLocation();
  },
  methods: {
     addNewLoadType_1A() {
      this.board[0].loadType_1A.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1A(idx) {
      this.board[0].loadType_1A.splice(idx, 1);
    },
    addNewLoadType_2A() {
      this.board[0].loadType_2A.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2A(idx) {
      this.board[0].loadType_2A.splice(idx, 1);
    },
    addNewLoadType_3A() {
      this.board[0].loadType_3A.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3A(idx) {
      this.board[0].loadType_3A.splice(idx, 1);
    },
    addNewLoadType_4A() {
      this.board[0].loadType_4A.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4A(idx) {
      this.board[0].loadType_4A.splice(idx, 1);
    },

   addNewLoadType_1B() {
      this.board[0].loadType_1B.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1B(idx) {
      this.board[0].loadType_1B.splice(idx, 1);
    },
    addNewLoadType_2B() {
      this.board[0].loadType_2B.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2B(idx) {
      this.board[0].loadType_2B.splice(idx, 1);
    },
    addNewLoadType_3B() {
      this.board[0].loadType_3B.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3B(idx) {
      this.board[0].loadType_3B.splice(idx, 1);
    },
    addNewLoadType_4B() {
      this.board[0].loadType_4B.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4B(idx) {
      this.board[0].loadType_4B.splice(idx, 1);
    },

    addNewLoadType_1C() {
      this.board[0].loadType_1C.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1C(idx) {
      this.board[0].loadType_1C.splice(idx, 1);
    },
    addNewLoadType_2C() {
      this.board[0].loadType_2C.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2C(idx) {
      this.board[0].loadType_2C.splice(idx, 1);
    },
    addNewLoadType_3C() {
      this.board[0].loadType_3C.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3C(idx) {
      this.board[0].loadType_3C.splice(idx, 1);
    },
    addNewLoadType_4C() {
      this.board[0].loadType_4C.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4C(idx) {
      this.board[0].loadType_4C.splice(idx, 1);
    },

    addNewLoadType_1D() {
      this.board[0].loadType_1D.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1D(idx) {
      this.board[0].loadType_1D.splice(idx, 1);
    },
    addNewLoadType_2D() {
      this.board[0].loadType_2D.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2D(idx) {
      this.board[0].loadType_2D.splice(idx, 1);
    },
    addNewLoadType_3D() {
      this.board[0].loadType_3D.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3D(idx) {
      this.board[0].loadType_3D.splice(idx, 1);
    },
    addNewLoadType_4D() {
      this.board[0].loadType_4D.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4D(idx) {
      this.board[0].loadType_4D.splice(idx, 1);
    },

    addNewLoadType_1E() {
      this.board[0].loadType_1E.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1E(idx) {
      this.board[0].loadType_1E.splice(idx, 1);
    },
    addNewLoadType_2E() {
      this.board[0].loadType_2E.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2E(idx) {
      this.board[0].loadType_2E.splice(idx, 1);
    },
    addNewLoadType_3E() {
      this.board[0].loadType_3E.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3E(idx) {
      this.board[0].loadType_3E.splice(idx, 1);
    },
    addNewLoadType_4E() {
      this.board[0].loadType_4E.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4E(idx) {
      this.board[0].loadType_4E.splice(idx, 1);
    },

    addNewLoadType_1F() {
      this.board[0].loadType_1F.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1F(idx) {
      this.board[0].loadType_1F.splice(idx, 1);
    },
    addNewLoadType_2F() {
      this.board[0].loadType_2F.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2F(idx) {
      this.board[0].loadType_2F.splice(idx, 1);
    },
    addNewLoadType_3F() {
      this.board[0].loadType_3F.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3F(idx) {
      this.board[0].loadType_3F.splice(idx, 1);
    },
    addNewLoadType_4F() {
      this.board[0].loadType_4F.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4F(idx) {
      this.board[0].loadType_4F.splice(idx, 1);
    },

    addNewLoadType_1G() {
      this.board[0].loadType_1G.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1G(idx) {
      this.board[0].loadType_1G.splice(idx, 1);
    },
    addNewLoadType_2G() {
      this.board[0].loadType_2G.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2G(idx) {
      this.board[0].loadType_2G.splice(idx, 1);
    },
    addNewLoadType_3G() {
      this.board[0].loadType_3G.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3G(idx) {
      this.board[0].loadType_3G.splice(idx, 1);
    },
    addNewLoadType_4G() {
      this.board[0].loadType_4G.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4G(idx) {
      this.board[0].loadType_4G.splice(idx, 1);
    },

    addNewLoadType_1H() {
      this.board[0].loadType_1H.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1H(idx) {
      this.board[0].loadType_1H.splice(idx, 1);
    },
    addNewLoadType_2H() {
      this.board[0].loadType_2H.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2H(idx) {
      this.board[0].loadType_2H.splice(idx, 1);
    },
    addNewLoadType_3H() {
      this.board[0].loadType_3H.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3H(idx) {
      this.board[0].loadType_3H.splice(idx, 1);
    },
    addNewLoadType_4H() {
      this.board[0].loadType_4H.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4H(idx) {
      this.board[0].loadType_4H.splice(idx, 1);
    },

    loadsConsole: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/serial-number-ecms-con";
    axios.get(apiURL).then(res => {
    this.console = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    loadsSensor: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/serial-number-ecms-sen";
    axios.get(apiURL).then(res => {
    this.sensor = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
  loadsLocation: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/location";
    axios.get(apiURL).then(res => {
    this.location = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    loadsBoard: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/board/" + this.$route.params.id;
    axios.get(apiURL).then(res => {
    this.board = res.data;
    }).catch(error => {
        console.log(error)
    });
    },

    async saveItem() {
      if (this.$refs.form.validate()) {
    let apiURL = process.env.VUE_APP_API + "/api/update-board/" + this.$route.params.id;
      axios
        .post(apiURL,
      {
    chConsoleLabel: this.board[0].chConsoleLabel,
    chConsoleSn: this.board[0].chConsoleSn,
    totalSensor: this.board[0].totalSensor,
    chSensorLabel1: this.board[0].chSensorLabel1,
    chSensorSn1: this.board[0].chSensorSn1,
    chSensorLabel2: this.board[0].chSensorLabel2,
    chSensorSn2: this.board[0].chSensorSn2,
    chSensorLabel3: this.board[0].chSensorLabel3,
    chSensorSn3: this.board[0].chSensorSn3,
    chSensorLabel4: this.board[0].chSensorLabel4,
    chSensorSn4: this.board[0].chSensorSn4,

    ryb1A: this.board[0].ryb1A,
    boardName1: this.board[0].boardName1,
    location1A: this.board[0].location1A,
    loadType_1A: this.board[0].loadType_1A,
    
    ryb2A: this.board[0].ryb2A,
    boardName2: this.board[0].boardName2,
    location2A: this.board[0].location2A,
    loadType_2A: this.board[0].loadType_2A,
    
    ryb3A: this.board[0].ryb3A,
    boardName3: this.board[0].boardName3,
    location3A: this.board[0].location3A,
    loadType_3A: this.board[0].loadType_3A,
    
    ryb4A: this.board[0].ryb4A,
    boardName4: this.board[0].boardName4,
    location4A: this.board[0].location4A,
    loadType_4A: this.board[0].loadType_4A,

    ryb1B: this.board[0].ryb1B,
    location1B: this.board[0].location1B,
    loadType_1B: this.board[0].loadType_1B,

    ryb2B: this.board[0].ryb2B,
    location2B: this.board[0].location2B,
    loadType_2B: this.board[0].loadType_2B,

    ryb3B: this.board[0].ryb3B,
    location3B: this.board[0].location3B,
    loadType_3B: this.board[0].loadType_3B,

    ryb4B: this.board[0].ryb4B,
    location4B: this.board[0].location4B,
    loadType_4B: this.board[0].loadType_4B,

    ryb1C: this.board[0].ryb1C,
    location1C: this.board[0].location1C,
    loadType_1C: this.board[0].loadType_1C,

    ryb2C: this.board[0].ryb2C,
    location2C: this.board[0].location2C,
    loadType_2C: this.board[0].loadType_2C,

    ryb3C: this.board[0].ryb3C,
    location3C: this.board[0].location3C,
    loadType_3C: this.board[0].loadType_3C,

    ryb4C: this.board[0].ryb4C,
    location4C: this.board[0].location4C,
    loadType_4C: this.board[0].loadType_4C,

    ryb1D: this.board[0].ryb1D,
    location1D: this.board[0].location1D,
    loadType_1D: this.board[0].loadType_1D,

    ryb2D: this.board[0].ryb2D,
    location2D: this.board[0].location2D,
    loadType_2D: this.board[0].loadType_2D,

    ryb3D: this.board[0].ryb3D,
    location3D: this.board[0].location3D,
    loadType_3D: this.board[0].loadType_3D,

    ryb4D: this.board[0].ryb4D,
    location4D: this.board[0].location4D,
    loadType_4D: this.board[0].loadType_4D,

    ryb1E: this.board[0].ryb1E,
    location1E: this.board[0].location1E,
    loadType_1E: this.board[0].loadType_1E,

    ryb2E: this.board[0].ryb2E,
    location2E: this.board[0].location2E,
    loadType_2E: this.board[0].loadType_2E,

    ryb3E: this.board[0].ryb3E,
    location3E: this.board[0].location3E,
    loadType_3E: this.board[0].loadType_3E,

    ryb4E: this.board[0].ryb4E,
    location4E: this.board[0].location4E,
    loadType_4E: this.board[0].loadType_4E,

    ryb1F: this.board[0].ryb1F,
    location1F: this.board[0].location1F,
    loadType_1F: this.board[0].loadType_1F,

    ryb2F: this.board[0].ryb2F,
    location2F: this.board[0].location2F,
    loadType_2F: this.board[0].loadType_2F,

    ryb3F: this.board[0].ryb3F,
    location3F: this.board[0].location3F,
    loadType_3F: this.board[0].loadType_3F,

    ryb4F: this.board[0].ryb4F,
    location4F: this.board[0].location4F,
    loadType_4F: this.board[0].loadType_4F,

    ryb1G: this.board[0].ryb1G,
    location1G: this.board[0].location1G,
    loadType_1G: this.board[0].loadType_1G,

    ryb2G: this.board[0].ryb2G,
    location2G: this.board[0].location2G,
    loadType_2G: this.board[0].loadType_2G,

    ryb3G: this.board[0].ryb3G,
    location3G: this.board[0].location3G,
    loadType_3G: this.board[0].loadType_3G,

    ryb4G: this.board[0].ryb4G,
    location4G: this.board[0].location4G,
    loadType_4G: this.board[0].loadType_4G,

    ryb1H: this.board[0].ryb1H,
    location1H: this.board[0].location1H,
    loadType_1H: this.board[0].loadType_1H,

    ryb2H: this.board[0].ryb2H,
    location2H: this.board[0].location2H,
    loadType_2H: this.board[0].loadType_2H,

    ryb3H: this.board[0].ryb3H,
    location3H: this.board[0].location3H,
    loadType_3H: this.board[0].loadType_3H,

    ryb4H: this.board[0].ryb4H,
    location4H: this.board[0].location4H,
    loadType_4H: this.board[0].loadType_4H,
    modifiedBy: this.$keycloak.tokenParsed.given_name
        });
        
    }
     router.go(-1);
      }
    }
  };

</script>